import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=2950865e&scoped=true"
import script from "./LeadDetails.vue?vue&type=script&lang=ts"
export * from "./LeadDetails.vue?vue&type=script&lang=ts"
import style0 from "./LeadDetails.vue?vue&type=style&index=0&id=2950865e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950865e",
  null
  
)

export default component.exports